/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import ChipInput from 'material-ui-chip-input';

// assets
import CssField from '../Field.scss';
import CssInput from '../Input/Input.scss';

function TagBox(props) {
  useStyles(CssField, CssInput);
  const [helperText, setHelperText] = useState(null);

  const {
    input,
    label,
    meta: { touched, error },
  } = props;

  const handleTagAdd = tag => {
    input.onChange([...input.value, tag]);
    setHelperText(null);
  };

  const handleTagDelete = tag => {
    input.onChange(input.value.filter(existing => existing !== tag));
    setHelperText(null);
  };

  const handleBeforeTagAdd = tag => {
    if (!tag) {
      setHelperText(null);
      return false;
    }
    if (!/^[a-z0-9 \-_]+$/i.test(tag)) {
      setHelperText('Tags can contain letters, numbers, spaces, hyphen and underscores');
      return false;
    }
    if (tag.length > 30) {
      setHelperText('Tags can be up to 30 characters long');
      return false;
    }
    return true;
  };

  const inputClassNames = classNames('field__input', { 'field__input--error': touched && error });
  return (
    <div className="field field--input">
      <div className="field__wrapper">
        <ChipInput
          disableUnderline
          alwaysShowPlaceholder
          className={inputClassNames}
          value={input.value}
          onAdd={handleTagAdd}
          onDelete={handleTagDelete}
          onBeforeAdd={handleBeforeTagAdd}
          placeholder={input.value && input.value.length ? 'Type to add more...' : label}
        />
      </div>
      {helperText ? (
        <div className="field__message">{helperText}</div>
      ) : (
        <div className="field__message">{touched && error ? error : null}</div>
      )}
    </div>
  );
}

TagBox.propTypes = {
  type: PropTypes.string,
  ...fieldPropTypes,
};

TagBox.defaultProps = {
  type: 'text',
};

export default TagBox;
